import { useEffect } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useNavigate, useLocation } from "react-router-dom";

import Unlogged from './pages/security/Unlogged';
import LayoutPage from './pages/layoutPage/LayoutPage';
import Loader from './components/widgets/Loader';
import { ErrorBoundary } from "react-error-boundary";
import { useCheckFrontEndVersion } from './hooks/useCheckFrontEndVersion';

import 'bootstrap/dist/css/bootstrap.min.css';
import './app.scss';

function App() {
  const { sharedSlugs, isFetchNecessary:isFetchParamsNecessary } = useStoreState(state => state.params);
  const { fetchParams } = useStoreActions(actions => actions.params);

  const { isLogged, isLogging, shouldCheckAuth } = useStoreState(state => state.auth);
  const {shouldNavigate, path } = useStoreState(state => state.navigation );
  const { getAuthStatus,  } = useStoreActions(actions => actions.auth);

  const {getActions} = useStoreActions(actions => actions.actionSlugs);

  const OutdatedModal = useCheckFrontEndVersion();

  const navigate = useNavigate();

  useEffect(() => {
    if(isFetchParamsNecessary) {
      fetchParams();
    }
  }, [isFetchParamsNecessary, fetchParams]);

  useEffect(() => {
    if (!isFetchParamsNecessary && shouldCheckAuth) {
      getAuthStatus()
        .then(res => {
          getActions();
        });
    }
    if(isLogged){
        const payload = {checkAtInterval: true} 
        const interval = setInterval(() => {getAuthStatus(payload);},1000*60*20);
        return () => {
            clearInterval(interval);
        };
    }
  }, [getAuthStatus, getActions, shouldCheckAuth, isFetchParamsNecessary]);

  useEffect(() => {
    if(shouldNavigate) {
      navigate(path);
    }
  },[shouldNavigate, path, navigate]);

  const location = useLocation();
  const userActivation = location.pathname.includes(sharedSlugs.activation);


  function Fallback({ error }) {

    const copyToClipboard = async (text) => {
      await navigator.clipboard.writeText(text);
    }

    const hardReload = () => {
      const url = new URL(window.location.href);
      url.searchParams.set('reload', Date.now());
      window.location.href = url.toString();
    }

    return <div className='error-page'>
      <div role="alert" className='error-message'>
            <p>Une erreur a empêché le chargement de la page, nous vous invitons à la recharger :</p>
            <div className='d-flex w-100 justify-content-center'>
                <button
                    className="refresh-button"
            onClick={hardReload}>Recharger la page</button>
            </div>
            <p>Si le problème persiste, vous pouvez transmettre le message suivant à nos équipes techniques :</p>
        <pre style={{ color: "red" }}>{error.message} <button className='error-copy' onClick={() => copyToClipboard(error.message)}>copier</button></pre>
      </div>
    </div>;
  }

  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <OutdatedModal />
      {
        (!isLogging && isLogged && !userActivation) && <LayoutPage />
      }
      {
        ((!isLogging && !isLogged) || userActivation) && <Unlogged />  
      }
      {
        isLogging && <Loader />
      }
    </ErrorBoundary>
    );
}

export default App;
